export default __webpack_public_path__ + "static/seatsplanet-about-bg-7bfb6642fa6862b510f79fe5b741fcf1.jpg";